/* ==========================================================================
   HL Fit Hub — theme.js
   Vanilla port of the original React behaviour (cart drawer, search,
   cookie consent + Microsoft UET consent mode, Herbalife member popup,
   Black Friday countdown, product page, Wellness Community unlock).
   ========================================================================== */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var HL = window.HL || {};

  /* ---------- helpers ---------- */
  var safeStorage = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
    remove: function (k) { try { window.localStorage.removeItem(k); } catch (e) {} }
  };
  function getCookie(name) {
    var m = document.cookie.split("; ").find(function (r) { return r.indexOf(name + "=") === 0; });
    return m ? decodeURIComponent(m.split("=")[1]) : "";
  }
  function setCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + (days || 1) * 864e5);
    document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
  }
  function formatMoney(cents, currency) {
    var value = cents / 100;
    try {
      return new Intl.NumberFormat("en-GB", { style: "currency", currency: currency || HL.currency || "GBP" }).format(value);
    } catch (e) { return "£" + value.toFixed(2); }
  }
  function imgSize(url, w) { if (!url) return ""; return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + w; }
  function uet() { window.uetq = window.uetq || []; return window.uetq; }
  function setLoading(btn, loading) {
    if (!btn) return;
    var l = $("[data-add-label]", btn), s = $("[data-add-loading]", btn);
    if (l) l.hidden = !!loading;
    if (s) s.hidden = !loading;
    btn.disabled = !!loading || btn.dataset.keepDisabled === "true";
  }

  /* ---------- Toasts (sonner replacement) ---------- */
  var toaster = $("[data-toaster]");
  function toast(opts) {
    if (!toaster) return;
    var el = document.createElement("div");
    el.className = "toast toast--" + (opts.type || "success");
    var icon = opts.type === "error"
      ? '<svg class="icon icon-md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>'
      : '<svg class="icon icon-md" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';
    el.innerHTML = icon + '<div class="toast__text"><div class="toast__title"></div>' + (opts.description ? '<div class="toast__desc"></div>' : "") + "</div>" + (opts.action ? '<button type="button" class="toast__action"></button>' : "");
    $(".toast__title", el).textContent = opts.title;
    if (opts.description) $(".toast__desc", el).textContent = opts.description;
    if (opts.action) {
      var b = $(".toast__action", el); b.textContent = opts.action.label;
      b.addEventListener("click", function () { opts.action.onClick(); el.remove(); });
    }
    toaster.appendChild(el);
    setTimeout(function () { el.remove(); }, 4000);
  }

  /* ---------- Sheet (drawer) helper ---------- */
  function makeSheet(el, openSel, closeSel) {
    if (!el) return { open: function () {}, close: function () {} };
    function open() { el.classList.add("is-open"); el.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
    function close() { el.classList.remove("is-open"); el.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; }
    $$(openSel).forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); open(); }); });
    $$(closeSel, el).forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); close(); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && el.classList.contains("is-open")) close(); });
    return { open: open, close: close, el: el };
  }

  var navSheet = makeSheet($("[data-nav-sheet]"), "[data-nav-open]", "[data-nav-close]");
  var cartSheet = makeSheet($("[data-cart-sheet]"), "[data-cart-open]", "[data-cart-close]");

  /* ---------- Shop dropdown ---------- */
  $$("[data-dropdown]").forEach(function (dd) {
    var trigger = $("[data-dropdown-trigger]", dd);
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      var open = dd.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
    document.addEventListener("mousedown", function (e) {
      if (!dd.contains(e.target)) { dd.classList.remove("is-open"); trigger.setAttribute("aria-expanded", "false"); }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") dd.classList.remove("is-open"); });
  });

  /* ---------- Cart (Shopify AJAX API) ---------- */
  var Cart = {
    data: null,
    busy: false,
    fetch: function () {
      return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    add: function (formDataOrItems) {
      var body = formDataOrItems instanceof FormData ? formDataOrItems : JSON.stringify(formDataOrItems);
      var headers = formDataOrItems instanceof FormData ? { Accept: "application/json" } : { Accept: "application/json", "Content-Type": "application/json" };
      return fetch("/cart/add.js", { method: "POST", body: body, headers: headers }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Could not add to basket"); return j; });
      });
    },
    change: function (line, quantity) {
      return fetch("/cart/change.js", { method: "POST", headers: { Accept: "application/json", "Content-Type": "application/json" }, body: JSON.stringify({ line: line, quantity: quantity }) })
        .then(function (r) { return r.json(); }).then(function (c) { Cart.data = c; Cart.render(); return c; });
    },
    render: function () {
      var c = Cart.data; if (!c) return;
      var count = c.item_count;
      $$("[data-cart-count]").forEach(function (b) { b.textContent = count; b.hidden = count === 0; });
      var summary = $("[data-cart-summary]"); if (summary) summary.textContent = count === 0 ? "Your basket is empty." : count + " item" + (count !== 1 ? "s" : "");
      var empty = $("[data-cart-empty]"), emptyLink = $("[data-cart-empty-link]"), lines = $("[data-cart-lines]"), footer = $("[data-cart-footer]");
      if (!lines) return;
      if (count === 0) { empty.hidden = false; emptyLink.hidden = false; lines.hidden = true; footer.hidden = true; lines.innerHTML = ""; return; }
      empty.hidden = true; emptyLink.hidden = true; lines.hidden = false; footer.hidden = false;
      var tpl = $("[data-cart-line-template]");
      lines.innerHTML = "";
      c.items.forEach(function (item, idx) {
        var node = tpl.content.cloneNode(true);
        var img = $("img", node);
        if (item.image) { img.src = imgSize(item.image, 200); img.alt = item.product_title; } else { img.remove(); }
        $("[data-line-title]", node).textContent = item.product_title;
        var opts = $("[data-line-options]", node);
        if (item.variant_title && item.variant_title !== "Default Title") { opts.textContent = (item.options_with_values || []).map(function (o) { return o.value; }).join(" • ") || item.variant_title; opts.hidden = false; }
        var props = $("[data-line-props]", node);
        var keys = Object.keys(item.properties || {}).filter(function (k) { return item.properties[k]; });
        if (keys.length) { props.hidden = false; keys.forEach(function (k) { var li = document.createElement("li"); li.innerHTML = "<span></span> "; $("span", li).textContent = k + ":"; li.appendChild(document.createTextNode(item.properties[k])); props.appendChild(li); }); }
        $("[data-line-price]", node).textContent = formatMoney(item.final_price, c.currency);
        $("[data-line-qty]", node).textContent = item.quantity;
        var line = idx + 1;
        $("[data-line-remove]", node).setAttribute("aria-label", "Remove " + item.product_title + " from basket");
        $("[data-line-minus]", node).setAttribute("aria-label", "Decrease quantity of " + item.product_title);
        $("[data-line-plus]", node).setAttribute("aria-label", "Increase quantity of " + item.product_title);
        $("[data-line-remove]", node).addEventListener("click", function () { Cart.mutate(line, 0); });
        $("[data-line-minus]", node).addEventListener("click", function () { Cart.mutate(line, item.quantity - 1); });
        $("[data-line-plus]", node).addEventListener("click", function () { Cart.mutate(line, item.quantity + 1); });
        lines.appendChild(node);
      });
      $("[data-cart-total]").textContent = formatMoney(c.items_subtotal_price, c.currency);
    },
    mutate: function (line, qty) {
      if (Cart.busy) return; Cart.busy = true;
      $$("[data-cart-lines] button").forEach(function (b) { b.disabled = true; });
      Cart.change(line, qty).catch(function () { Cart.fetch(); }).then(function () { Cart.busy = false; });
    },
    addAndNotify: function (payload, btn, title) {
      if (Cart.busy) return; Cart.busy = true; setLoading(btn, true);
      Cart.add(payload).then(function () { return Cart.fetch(); }).then(function () {
        toast({ type: "success", title: "Added to basket", description: title, action: { label: "View basket", onClick: cartSheet.open } });
        cartSheet.open();
      }).catch(function (err) {
        toast({ type: "error", title: "Could not add to basket — please try again", description: err && err.message ? err.message : undefined });
      }).then(function () { Cart.busy = false; setLoading(btn, false); });
    }
  };
  Cart.fetch();
  document.addEventListener("visibilitychange", function () { if (document.visibilityState === "visible") Cart.fetch(); });
  if (cartSheet.el) { $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function () { Cart.fetch(); }); }); }

  // Product cards: quick add
  $$("[data-add-to-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      Cart.addAndNotify({ items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }] }, btn, btn.dataset.productTitle);
    });
  });

  /* ---------- Product page ---------- */
  var pform = $("[data-product-form]");
  if (pform) {
    var variantInput = $("[data-variant-input]", pform);
    var submitBtn = $("[data-add-submit]", pform);
    var unavailable = $("[data-unavailable]");
    var kitHint = $("[data-kit-hint]");
    var kitSelects = $$("[data-kit-select]", pform);
    var state = { available: !submitBtn.disabled };

    function refreshSubmit() {
      var missing = kitSelects.some(function (s) { return !s.value; });
      var can = state.available && !missing;
      submitBtn.disabled = !can;
      submitBtn.dataset.keepDisabled = can ? "false" : "true";
      if (kitHint) kitHint.hidden = !(missing && state.available);
      if (unavailable) unavailable.hidden = state.available;
    }
    kitSelects.forEach(function (s) { s.addEventListener("change", refreshSubmit); });

    $$("[data-variant-pill]", pform).forEach(function (pill) {
      pill.addEventListener("click", function () {
        $$("[data-variant-pill]", pform).forEach(function (p) { p.classList.remove("is-active"); p.setAttribute("aria-pressed", "false"); });
        pill.classList.add("is-active"); pill.setAttribute("aria-pressed", "true");
        variantInput.value = pill.dataset.variantId;
        $("[data-price]").textContent = pill.dataset.price;
        var cmp = $("[data-compare]"), promo = $("[data-promo]");
        cmp.textContent = pill.dataset.compare; cmp.hidden = !pill.dataset.compare;
        if (promo) promo.hidden = !pill.dataset.compare;
        state.available = pill.dataset.available === "true";
        refreshSubmit();
      });
    });
    refreshSubmit();

    pform.addEventListener("submit", function (e) {
      e.preventDefault();
      if (submitBtn.disabled) return;
      var fd = new FormData(pform);
      fd.append("quantity", "1");
      Cart.addAndNotify(fd, submitBtn, submitBtn.dataset.productTitle);
    });
  }

  /* ---------- Search bar (predictive search) ---------- */
  var sb = $("[data-searchbar]");
  if (sb) {
    var input = $("[data-search-input]", sb), results = $("[data-search-results]", sb), clearBtn = $("[data-search-clear]", sb), form = $("[data-search-form]", sb);
    var timer = null, open = false;
    function show() { open = true; results.hidden = false; }
    function hide() { open = false; results.hidden = true; }
    function esc(s) { var d = document.createElement("div"); d.textContent = s || ""; return d.innerHTML; }
    function render(q, items) {
      if (!items.length) { results.innerHTML = '<div class="searchbar__state">No products found for "' + esc(q) + '".</div>'; return; }
      var html = '<ul class="searchbar__list">';
      items.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? imgSize(p.featured_image.url, 96) : "";
        var price = p.price ? "£" + (parseFloat(p.price)).toFixed(2) : "";
        try { if (p.price) price = new Intl.NumberFormat("en-GB", { style: "currency", currency: HL.currency || "GBP" }).format(parseFloat(p.price)); } catch (e) {}
        var desc = esc((p.body || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim());
        html += '<li><a href="' + p.url + '" class="searchbar__item"><div class="thumb">' + (img ? '<img src="' + img + '" alt="' + esc(p.title) + '" loading="lazy">' : "") + '</div><div class="meta"><p class="title line-clamp-1">' + esc(p.title) + '</p><p class="desc line-clamp-1">' + desc + '</p></div><span class="price">' + price + "</span></a></li>";
      });
      html += '<li><a href="/collections/all" class="searchbar__all">View all products →</a></li></ul>';
      results.innerHTML = html;
    }
    function search(q) {
      results.innerHTML = '<div class="searchbar__state"><svg class="icon spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Searching…</div>';
      show();
      var url = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,tag";
      fetch(url, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (j) {
        var items = (j.resources && j.resources.results && j.resources.results.products) || [];
        render(q, items);
      }).catch(function () { render(q, []); });
    }
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearBtn.hidden = !input.value;
      clearTimeout(timer);
      if (q.length < 2) { hide(); results.innerHTML = ""; return; }
      timer = setTimeout(function () { search(q); }, 250);
    });
    input.addEventListener("focus", function () { if (input.value.trim().length >= 2 && results.innerHTML) show(); });
    clearBtn.addEventListener("click", function () { input.value = ""; clearBtn.hidden = true; results.innerHTML = ""; hide(); input.focus(); });
    document.addEventListener("mousedown", function (e) { if (!sb.contains(e.target)) hide(); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var q = input.value.trim(); if (!q) return;
      hide();
      window.location.href = "/collections/all";
    });
  }

  /* ---------- Cookie consent (hlfithub-cookie-consent-v1) + Microsoft UET consent mode ---------- */
  var COOKIE_KEY = "hlfithub-cookie-consent-v1";
  function getConsent() { try { var r = safeStorage.get(COOKIE_KEY); return r ? JSON.parse(r) : null; } catch (e) { return null; } }
  var banner = $("[data-cookie-banner]"), dialog = $("[data-cookie-dialog]");
  if (banner && dialog) {
    var sw = {}; $$("[data-cookie-switch]", dialog).forEach(function (b) { sw[b.dataset.cookieSwitch] = b; b.addEventListener("click", function () { b.setAttribute("aria-checked", b.getAttribute("aria-checked") === "true" ? "false" : "true"); }); });
    function loadSwitches() { var c = getConsent(); if (c) { sw.analytics.setAttribute("aria-checked", c.analytics ? "true" : "false"); sw.marketing.setAttribute("aria-checked", c.marketing ? "true" : "false"); } }
    function openDialog() { loadSwitches(); dialog.classList.add("is-open"); dialog.setAttribute("aria-hidden", "false"); }
    function closeDialog() { dialog.classList.remove("is-open"); dialog.setAttribute("aria-hidden", "true"); }
    function save(analytics, marketing) {
      var payload = { necessary: true, analytics: !!analytics, marketing: !!marketing, timestamp: new Date().toISOString() };
      safeStorage.set(COOKIE_KEY, JSON.stringify(payload));
      uet().push("consent", "update", { ad_storage: payload.marketing ? "granted" : "denied" });
      // Shopify Customer Privacy API (keeps Shopify's own tracking aligned with the choice)
      try {
        if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
          window.Shopify.customerPrivacy.setTrackingConsent({ analytics: payload.analytics, marketing: payload.marketing, preferences: true, sale_of_data: payload.marketing }, function () {});
        }
      } catch (e) {}
      window.dispatchEvent(new CustomEvent("cookie-consent-changed", { detail: payload }));
      banner.hidden = true; closeDialog();
    }
    if (!getConsent()) banner.hidden = false;
    $$("[data-cookie-accept]").forEach(function (b) { b.addEventListener("click", function () { save(true, true); }); });
    $$("[data-cookie-reject]").forEach(function (b) { b.addEventListener("click", function () { save(false, false); }); });
    $$("[data-cookie-save]").forEach(function (b) { b.addEventListener("click", function () { save(sw.analytics.getAttribute("aria-checked") === "true", sw.marketing.getAttribute("aria-checked") === "true"); }); });
    $$("[data-cookie-settings-open]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); openDialog(); }); });
    $$("[data-cookie-dialog-close]", dialog).forEach(function (b) { b.addEventListener("click", closeDialog); });
    window.addEventListener("open-cookie-settings", openDialog);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDialog(); });
  }

  /* ---------- Herbalife Independent Member popup (home only, once per day) ---------- */
  var popup = $("[data-member-popup]");
  if (popup) {
    if (getCookie("wc_popup_herba") !== "shown") { popup.classList.add("is-open"); setCookie("wc_popup_herba", "shown", 1); }
    $$("[data-member-popup-close]", popup).forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); popup.classList.remove("is-open"); }); });
  }

  /* ---------- Black Friday countdown ---------- */
  var cd = $("[data-countdown]");
  if (cd) {
    var end = new Date(cd.dataset.endsAt).getTime();
    function tick() {
      var left = Math.max(0, end - Date.now()); var s = Math.floor(left / 1000);
      var parts = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      Object.keys(parts).forEach(function (k) { $('[data-cd="' + k + '"]', cd).textContent = String(parts[k]).padStart(2, "0"); });
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Smooth scroll links ---------- */
  $$("[data-scroll-to]").forEach(function (a) {
    a.addEventListener("click", function (e) {
      var t = document.getElementById(a.dataset.scrollTo);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
  });

  /* ---------- Wellness Community ---------- */
  var wp = $("[data-wellness-page]");
  if (wp) {
    var W_KEY = "hlfithub.wellness.unlocked", W_PENDING = "hlfithub.wellness.pending";
    var wform = $("[data-wellness-form]"), wsuccess = $("[data-wellness-success]");
    var wname = $("[data-wellness-name]"), wemail = $("[data-wellness-email]"), wconsent = $("[data-wellness-consent]"), wsubmit = $("[data-wellness-submit]"), werror = $("[data-wellness-error]");

    function unlock(name, scroll) {
      $$("[data-premium]").forEach(function (r) { r.classList.remove("is-locked"); var b = $("[data-recipe-body]", r); if (b) b.removeAttribute("aria-hidden"); });
      if (wform) wform.hidden = true;
      if (wsuccess) { wsuccess.hidden = false; $("[data-wellness-savedname]", wsuccess).textContent = name ? ", " + name : ""; }
      if (scroll) setTimeout(function () { var t = document.getElementById("premium-recipes"); if (t) t.scrollIntoView({ behavior: "smooth", block: "start" }); }, 150);
    }

    var posted = window.HL_WELLNESS_POSTED === true || /(^|[?&])(customer_posted|contact_posted)=true/.test(window.location.search);
    var stored = safeStorage.get(W_KEY);
    if (posted) {
      var pending = safeStorage.get(W_PENDING) || stored || "";
      safeStorage.set(W_KEY, pending); safeStorage.remove(W_PENDING);
      unlock(pending, true);
      try { window.history.replaceState({}, "", window.location.pathname + "#premium-recipes"); } catch (e) {}
    } else if (stored) {
      unlock(stored, false);
    }

    if (wform) {
      function valid() {
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(wemail.value.trim());
        return wname.value.trim().length > 0 && emailOk && wconsent.checked;
      }
      function refresh() { wsubmit.disabled = !valid(); }
      [wname, wemail].forEach(function (i) { i.addEventListener("input", refresh); });
      wconsent.addEventListener("change", refresh);
      refresh();
      wform.addEventListener("submit", function (e) {
        werror.hidden = true;
        if (!wconsent.checked) { e.preventDefault(); werror.textContent = "Please tick the consent box to continue."; werror.hidden = false; return; }
        if (!valid()) { e.preventDefault(); werror.textContent = "Please enter your first name and a valid email address."; werror.hidden = false; return; }
        var first = wname.value.trim().slice(0, 100);
        safeStorage.set(W_PENDING, first);
        // Microsoft UET enhanced conversions: pass the user's email (no phone collected here).
        try { uet().push("set", { pid: { em: wemail.value.trim().toLowerCase(), ph: "" } }); } catch (err) {}
        setLoading(wsubmit, true);
      });
    }

    $$("[data-copy-code]").forEach(function (b) {
      b.addEventListener("click", function () {
        var idle = $("[data-copy-idle]", b), done = $("[data-copy-done]", b);
        navigator.clipboard.writeText(b.dataset.copyCode).then(function () {
          idle.hidden = true; done.hidden = false; setTimeout(function () { idle.hidden = false; done.hidden = true; }, 2000);
        }).catch(function () {});
      });
    });
  }

  /* ---------- Legacy URL handling (old Lovable routes) ---------- */
  // /shop is a reserved path on Shopify (renders the home page, server-side redirects don't apply):
  // send old /shop and /shop?category=slug links to the catalogue.
  if (/^\/shop\/?$/.test(window.location.pathname)) {
    var cm = window.location.search.match(/[?&]category=([a-z0-9-]+)/);
    window.location.replace(cm && cm[1] !== "all" ? "/collections/" + cm[1] : "/collections/all");
  }
  // /collections/all?category=slug  →  /collections/slug  (old /shop?category=slug links)
  if (HL.template === "collection") {
    var m = window.location.search.match(/[?&]category=([a-z0-9-]+)/);
    if (m && m[1] !== "all" && window.location.pathname === "/collections/all") {
      window.location.replace("/collections/" + m[1]);
    }
  }
  // Fallback on 404 for any legacy path that has no server-side redirect
  if ($("[data-notfound]")) {
    var p = window.location.pathname;
    var mp = p.match(/^\/product\/([^/]+)\/?$/);
    var legacyPages = ["about", "contact", "wellness", "weight-loss-plans", "black-friday", "privacy", "cookies", "terms"];
    if (mp) window.location.replace("/products/" + mp[1] + window.location.search);
    else if (p === "/shop" || p === "/shop/") window.location.replace("/collections/all" + window.location.search);
    else if (legacyPages.indexOf(p.replace(/^\/|\/$/g, "")) !== -1) window.location.replace("/pages/" + p.replace(/^\/|\/$/g, ""));
  }
})();
